exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-bar[data-v-6f2a995d] {\n  margin-bottom: 10px;\n}\n.select-campaign-type[data-v-6f2a995d] {\n  margin-top: 10px;\n  margin-bottom: 10px;\n  height: 34px;\n}\n.txt-last-month[data-v-6f2a995d] {\n  font-size: 1rem;\n  color: #636363;\n  margin-right: 3rem;\n}\n.value-last-month[data-v-6f2a995d] {\n  color: #636363;\n}\n.value-this-month[data-v-6f2a995d] {\n  font-weight: bold;\n}\n.vs-navbar[data-v-6f2a995d] {\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n}\n#startTour___BV_modal_outer_[data-v-6f2a995d] {\n  z-index: 90001 !important;\n}\n", ""]);

// exports
